const { $ } = window;

/**
 * Autocomplete entreprise du bloc de facturation (ajout de commande).
 *
 * La recherche interroge l'annuaire public via l'apiv2, relayée par une action sf1 : le voter
 * apiv2 exige le token du pro connecté, que la page n'a pas à exposer au navigateur.
 *
 * Le résultat n'est jamais autoritatif — il pré-remplit, l'organisateur corrige. Les champs
 * restent donc éditables, et « L'entreprise est introuvable ? » les ouvre vides.
 */
window.YP.AddOrderCompanySearch = () => ({
    // L'annuaire ne renvoie que du bruit en deçà ; l'action serveur applique le même seuil.
    MIN_LENGTH: 3,
    DEBOUNCE_MS: 300,

    // L'annuaire est français et ne renvoie pas de pays : c'est le seul défaut raisonnable.
    DEFAULT_COUNTRY: 'France',

    init() {
        this.timer = null;

        $(document).on('input', '.js-company-search', (e) => {
            window.clearTimeout(this.timer);
            const $input = $(e.currentTarget);
            this.timer = window.setTimeout(() => this.search($input), this.DEBOUNCE_MS);
        });

        $(document).on('click', '.js-company-results [data-company]', (e) => {
            e.preventDefault();
            this.fill($(e.currentTarget).closest('.js-company-billing'), $(e.currentTarget).data('company'));
        });

        $(document).on('click', '.js-company-not-found', (e) => {
            e.preventDefault();
            const $block = $(e.currentTarget).closest('.js-company-billing');
            this.closeResults($block);
            $block.find('.js-company-fields').show();
        });

        // Un clic ailleurs referme la liste sans rien choisir.
        $(document).on('click', (e) => {
            if (!$(e.target).closest('.js-company-billing').length) {
                this.closeResults($('.js-company-billing'));
            }
        });

        this.restore();
        // Le bloc arrive par ajax au passage à l'étape 2 (order.js).
        $(document).ajaxSuccess(() => this.restore());
    },

    /**
     * Au retour d'une validation en échec, le formulaire est re-rendu avec la facture entreprise
     * déjà cochée et remplie : sans ceci, les champs à corriger resteraient masqués.
     */
    restore() {
        $('.js-company-billing').each((index, block) => {
            const $block = $(block);
            const $fields = $block.find('.js-company-fields');
            const isFilled = $fields.find('[data-company-field]').toArray()
                .some((field) => $(field).val());

            if (isFilled || $fields.find('.c-form-item--error').length) {
                $block.show();
                $fields.show();
            }
        });
    },

    search($input) {
        const $block = $input.closest('.js-company-billing');
        const term = $input.val().trim();

        if (term.length < this.MIN_LENGTH) {
            this.closeResults($block);
            return;
        }

        $.getJSON($block.data('search-url'), { q: term })
            .done((companies) => this.renderResults($block, companies))
            // Annuaire injoignable : on ne dit rien et on laisse la saisie manuelle faire le
            // travail. Bloquer la commande sur un service de confort serait disproportionné.
            .fail(() => this.closeResults($block));
    },

    renderResults($block, companies) {
        const $results = $block.find('.js-company-results').empty();

        if (!companies || !companies.length) {
            $results.hide();
            return;
        }

        companies.forEach((company) => {
            const location = [company.postalCode, company.city].filter(Boolean).join(' ');
            const details = [company.siret, location].filter(Boolean).join(' · ');

            // Pas de `--link` : son chevron laisserait croire à une navigation.
            $('<li>')
                .addClass('c-list__item')
                .attr('data-company', JSON.stringify(company))
                .append($('<div>').addClass('c-form-label mb-0').text(company.name))
                .append($('<div>').addClass('c-form-info').text(details))
                .appendTo($results);
        });

        $results.show();
    },

    fill($block, company) {
        const values = {
            company: company.name,
            siret: company.siret,
            streets: company.streetAddress,
            city: company.city,
            zipcode: company.postalCode,
            country: this.DEFAULT_COUNTRY,
        };

        Object.keys(values).forEach((field) => {
            $block.find(`[data-company-field="${field}"]`).val(values[field] || '');
        });

        this.closeResults($block);
        $block.find('.js-company-fields').show();
    },

    closeResults($block) {
        $block.find('.js-company-results').hide().empty();
    },
});

window.addEventListener('load', () => window.YP.AddOrderCompanySearch().init());
